export const neighborhoodSnakeCase = (name = '') => {
  const removeSlash = name.replace(' /', '').toLowerCase();
  const formatName = removeSlash.split(' ').join('-');
  return formatName;
};
